import * as React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel';
import Paper from '@mui/material/Paper';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import { visuallyHidden } from '@mui/utils';
import { obtenerlotes } from '../../../Redux/LotesDucks';
import { useDispatch } from 'react-redux';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { styled } from '@mui/material/styles';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import Badge from '@mui/material/Badge';

import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import {
  Link
} from "react-router-dom";
import { IconButton, Typography } from '@mui/material';
import SwitchStatusLote from './SwitchStatusLote';
import EliminarLote from './EliminarLote';
import BotonResuemenPDF from './BotonResuemenPDF';
import SubtringLote from './SubtringLote';
import Filtros from './Filtros';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

// This method is created for cross-browser compatibility, if you don't
// need to support IE11, you can use Array.prototype.sort() directly
function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

const headCells = [
  {
    id: 'idlote',
    numeric: false,
    disablePadding: false,
    label: 'ID',
  },

  {
    id: 'empresa',
    numeric: false,
    disablePadding: false,
    label: 'EMPRESA',
  },
  {
    id: 'descdepto',
    numeric: false,
    disablePadding: false,
    label: 'DEPARTAMENTO',
  },
  {
    id: 'numeroperiodo',
    numeric: false,
    disablePadding: false,
    label: 'PERIODO',
  },
  {
    id: 'no_empleados',
    numeric: true,
    disablePadding: false,
    label: 'NO EMPLEADOS',
  },
  {
    id: 'usuarioregistra',
    numeric: true,
    disablePadding: false,
    label: 'REGISTRA',
  },
  {
    id: 'usuarioautoriza',
    numeric: true,
    disablePadding: false,
    label: 'AUTORIZA',
  },
  {
    id: 'usuariosincroniza',
    numeric: true,
    disablePadding: false,
    label: 'SINCRONIZA',
  },
  {
    id: 'estatus',
    numeric: true,
    disablePadding: false,
    label: 'STATUS',
  },
  {
    id: 'fecharegistro',
    numeric: true,
    disablePadding: false,
    label: 'ACCIONES',
  },

];

function EnhancedTableHead(props) {
  const { order, orderBy, onRequestSort } =
    props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead style={{ backgroundColor: 'rgba(128, 129, 146, 0.2)' }}>
      <TableRow>

        {headCells.map((headCell) => (
          <TableCell
            style={{ fontWeight: 'bold' }}
            key={headCell.id}
            align={headCell.numeric ? 'center' : 'center'}
            padding={headCell.disablePadding ? 'none' : 'normal'}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <Box component="span" sx={visuallyHidden}>
                  {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                </Box>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};



export default function TablaVistaLotes(props) {

  const dispatch = useDispatch();
  const [order, setOrder] = React.useState('desc');
  const [orderBy, setOrderBy] = React.useState('fecharegistro');
  const [page, setPage] = React.useState(0);
  const [dense, setDense] = React.useState(true);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const { rows } = props;

  React.useEffect(() => {
    const obtenerDatos = async () => {
      dispatch(obtenerlotes())
    }
    obtenerDatos()

  }, [dispatch])

  const obtenerloteact = () => {
    dispatch(obtenerlotes())
  }

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };


  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleChangeDense = (event) => {
    setDense(event.target.checked);
  };


  // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;

  if (!rows.length)
    return (
      <div style={{ paddingTop: 20, paddingBottom: 100, paddingLeft: 10, paddingRight: 10 }} >
        <Typography variant="h6">Sin datos para mostrar</Typography>
      </div>
    )

  return (
    <Box sx={{ width: '100%' }}>
      <Paper sx={{ width: '100%', mb: 2 }}>
   
                <TableContainer>
          <Table
            sx={{ minWidth: 750 }}
            aria-labelledby="tableTitle"
            size={dense ? 'small' : 'medium'}
          >
            <EnhancedTableHead
              order={order}
              orderBy={orderBy}
              onRequestSort={handleRequestSort}
              rowCount={rows.length}
            />
            <TableBody>
              {/* if you don't need to support IE11, you can replace the `stableSort` call with:
                 rows.slice().sort(getComparator(order, orderBy)) */}
              {stableSort(rows, getComparator(order, orderBy))
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row, index) => {
                  const labelId = `enhanced-table-checkbox-${index}`;

                  return (
                    <StyledTableRow
                      hover
                      tabIndex={-1}
                      key={index}
                    >
                      <StyledTableCell
                        align="center"
                      >
                        <SubtringLote
                          idlote={row.idlote}
                          align="center"
                          component="th"
                          id={labelId}
                        />
                      </StyledTableCell>

                      <StyledTableCell align="center">{row.empresa}</StyledTableCell>
                      <StyledTableCell align="center">{row.descdepto}</StyledTableCell>
                      <StyledTableCell
                        align="center"
                      >
                        {row.numeroperiodo}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        <Badge badgeContent={row.no_empleados} color="success">
                          <PeopleAltIcon />
                        </Badge>
                      </StyledTableCell>
                      <StyledTableCell  style={{width: '20%'}} align="center">{row.usuarioregistra}</StyledTableCell>
                      <StyledTableCell  style={{width: '20%'}} align="center">{row.usuarioautoriza}</StyledTableCell>
                      <StyledTableCell  align="center">{row.usuariosincroniza}</StyledTableCell>
                      <StyledTableCell  component="th" scope="row" width={50} align="center">
                        <SwitchStatusLote
                          status={row.estatus}
                        />
                      </StyledTableCell>
                      <StyledTableCell align='center'>
                        {row.estatus === 'Creado' ? <EliminarLote
                          estatus={row.estatus}
                          lote={row.idlote}
                          data={row}
                          obtenerloteact={obtenerloteact}
                        /> : null}

                        <Link to={`/incidencias/${row.idlote}`}>
                          <IconButton aria-label="Eye" size='small'>
                            <VisibilityIcon fontSize="small" />
                          </IconButton></Link>
                        <IconButton aria-label="Eye" size='small'>
                        </IconButton>
                        {row.estatus === 'Sincronizado' ? <BotonResuemenPDF
                          lote={row.idlote}
                        /> : null}

                      </StyledTableCell>
                    </StyledTableRow>
                  );
                })}
              {emptyRows > 0 && (
                <TableRow
                  style={{
                    height: (dense ? 33 : 53) * emptyRows,
                  }}
                >
                  <TableCell colSpan={6} />
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[5, 10, 50, { value: -1, label: 'Todos' }]}
          component="div"
          count={rows.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          labelRowsPerPage='Filas por página'
        />
      </Paper>
      <FormControlLabel
        control={<Switch color='success' checked={dense} onChange={handleChangeDense} />}
        label="Tabla pequeña"
      />
    </Box>
  );
}
